var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    d: "M0,0H20V20H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    opacity: 0.3,
    d: "M11.342,9.684a3.342,3.342,0,1,1,3.342-3.342A3.342,3.342,0,0,1,11.342,9.684Z",
    transform: "translate(-1.342 -0.493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    d: "M3,19.015C3.323,15.027,6.548,13,10.48,13c3.986,0,7.262,1.916,7.506,6.016a.573.573,0,0,1-.625.668H3.606A.924.924,0,0,1,3,19.015Z",
    transform: "translate(-0.493 -2.191)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0ff068e9092838e5bbd37662761679e2.svg";
export { ForwardRef as ReactComponent };